export const fullStar = 'full';
export const halfStar = 'half';
export const emptyStar = 'empty';

export const calculateStarType = (ratingStars, index) => {
    let type;
    if (ratingStars >= index + 1) {
        type = fullStar;
    } else if (ratingStars > index && ratingStars < index + 1) {
        type = halfStar;
    } else {
        type = emptyStar;
    }
    return type;
};
